"use client"

import type { ReactNode } from "react"
import { cn } from "@local/utils/src/cn"
import { ContentBlockServer } from "@local/ui/src/ContentBlockServer"
import { useMenuLayout } from "../../../lib/useMenuLayout"

interface PromoBannerSlideProps {
  children: ReactNode
}

export const PromoBannerSlide = ({ children }: PromoBannerSlideProps) => {
  const { isOpen: menuIsOpen } = useMenuLayout()

  return (
    <ContentBlockServer
      fullWidthBgColor={cn(
        "flex items-center justify-center h-8 md:h-8 align-middle font-semibold leading-tight absolute bg-brand-500 text-white transition-all",
        menuIsOpen ? "-top-8" : "top-0"
      )}
    >
      {children}
    </ContentBlockServer>
  )
}
